import { EMPTY_OBJECT } from '../../../../../../constants/common'
import {
  EMAIL_CREATION_FORM_FIELD_NAME_MESSAGE,
  EMAIL_CREATION_FORM_FIELD_NAME_TO,
  EMAIL_CREATION_FORM_TEST_VARIABLES_STATUS_PENDING,
  EMAIL_CREATION_FORM_TEST_VARIABLES_STATUS_STARTED,
} from '../../../EmailCreationForm.constants'
import { getTestVariablesRecipientId } from '../useTestVariables.utils'

function getRecipientsIds(values) {
  return values[EMAIL_CREATION_FORM_FIELD_NAME_TO].map(
    getTestVariablesRecipientId
  )
}

export function isTestVariablesStatusInProgress(status) {
  return (
    status === EMAIL_CREATION_FORM_TEST_VARIABLES_STATUS_PENDING ||
    status === EMAIL_CREATION_FORM_TEST_VARIABLES_STATUS_STARTED
  )
}

export function parseReport({ externalKey, result, template }) {
  const localReport = Object.keys(template?.[externalKey] || EMPTY_OBJECT)
    .filter(variable => template?.[externalKey][variable].length === 0)
    .map(variable => ({ external: true, variable }))

  return [...result, ...localReport]
}

export function getParamsTestGoogleTemplate(values, docTemplate) {
  return {
    dependencies: docTemplate.dependencies,
    recipients: getRecipientsIds(values),
    template: docTemplate.id,
  }
}

export function getParamsTestTextTemplate(values, textTemplate) {
  return {
    dependencies: textTemplate.dependencies,
    recipients: getRecipientsIds(values),
    text: values[EMAIL_CREATION_FORM_FIELD_NAME_MESSAGE],
  }
}
